// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountGetPartyDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountGetPartyDefaultResponse.attributeTypeMap;
    }
}
SiteAccountGetPartyDefaultResponse.discriminator = undefined;
SiteAccountGetPartyDefaultResponse.additionalProperties = false;
SiteAccountGetPartyDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "SiteModel"
    },
];
//# sourceMappingURL=siteAccountGetPartyDefaultResponse.js.map